/**
 * GA4 with Consent Mode v2: no analytics cookies until user accepts.
 * gtag is loaded from index.html (injected at build time when VITE_GA4_MEASUREMENT_ID is set).
 * This module only handles consent: applying existing consent on load and granting when user accepts.
 */

const CONSENT_KEY = 'impact-cookie-consent'

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

function hasConsent(): boolean {
  try {
    return localStorage.getItem(CONSENT_KEY) === 'true'
  } catch {
    return false
  }
}

/** Apply existing consent on page load (gtag loaded from index.html). */
export function initAnalytics(): void {
  if (typeof window.gtag !== 'function' || !hasConsent()) return
  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
  })
}

/** Call when user accepts cookies. Enables analytics cookies from this point. */
export function grantAnalyticsConsent(): void {
  if (typeof window.gtag !== 'function') return
  window.gtag('consent', 'update', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
  })
}
